import { render, staticRenderFns } from "./uploadModal.vue?vue&type=template&id=c7855552&lang=html"
import script from "./uploadModal.vue?vue&type=script&setup=true&lang=js"
export * from "./uploadModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_qhqm3mauky62uixplfzayyuc5e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports